const shippingFeesCountry = [{
  country: "kw",
  currency: "KWD",
  fees: 5,

}, {
  country: "sa",
  currency: "SAR",
  fees: 60,

}, {
  country: "om",
  currency: "OMR",
  fees: 7,

}, {
  country: "bh",
  currency: "BHD",
  fees: 15,

}, {
  country: "ae",
  currency: "AED",
  fees: 25,

}, {
  country: "qa",
  currency: "QAR",
  fees: 75,

}];

export default shippingFeesCountry;


// WEBPACK FOOTER //
// ./src/store/data/shipmentFees.js